import { Card, Row } from "antd";
import icon from "../../../../../../../images/warn-icon.svg";
import { ReactNode, useMemo } from "react";
import { PAYMENT_RESTRICTIONS } from "../../../../../../../lib/constants";
import { IOption } from "../../../../../../../types/Option";

type BannersProps = {
  paymentRestrictions: number;
  notifications: any[];
};

export const Banners = ({
  paymentRestrictions,
  notifications,
}: BannersProps) => {
  const freezeRestrictions: string[] = useMemo(
    () =>
      PAYMENT_RESTRICTIONS.filter((item: IOption) =>
        [1, 2].includes(item.value),
      ).map((item: IOption) => `Payment Restrictions: ${item.label}`),
    [],
  );

  const filteredNotifications = useMemo(() => {
    const filtered = notifications.filter(
      (item: any) => !freezeRestrictions.includes(item.message),
    );

    if ([1, 2].includes(paymentRestrictions)) {
      filtered.push({
        message: `Payment Restrictions: ${PAYMENT_RESTRICTIONS[paymentRestrictions].label}`,
      });
    }

    return filtered;
  }, [notifications, paymentRestrictions, freezeRestrictions]);

  const header: string = useMemo(() => {
    return filteredNotifications.length === 1
      ? filteredNotifications[0].message
      : "The account requires attention.";
  }, [filteredNotifications]);

  const title: ReactNode = useMemo(
    () => (
      <Row className="w-100 notifications-label px-4 py-2 align-center">
        <img alt="restricted" src={icon} className="mr-2" />
        <span className="label-value">{header}</span>
      </Row>
    ),
    [header],
  );

  if (filteredNotifications.length === 0) {
    return <Row />;
  }

  return filteredNotifications.length === 1 ? (
    title
  ) : (
    <Card title={title} className="notifications__container w-100 mb-4">
      <ul className="my-0 pl-5">
        {filteredNotifications.map((item: any, i: number) => (
          <li key={i}>{item.message}</li>
        ))}
      </ul>
    </Card>
  );
};
